import { MDXRemote } from "next-mdx-remote";

import { CImage, PersonList } from "../components";
import { getAboutData, getAllPeople, AboutPage } from "../lib/api";
import { getGlobalStaticProps } from "../lib/helpers";
import { mdxComponents } from "../lib/mdx";
import { Person } from "../lib/models";

interface AboutData {
  team: Person[];
  page: AboutPage;
}

export default function About({ data }: { data: AboutData }) {
  const { team, page } = data;
  return (
    <>
      <div className="py-8 py-lg-16 bg-white">
        <div className="container">
          {/* Content */}
          <div className="row">
            <div className="offset-lg-2 col-lg-8 col-md-12 col-12 mb-12">
              <MDXRemote {...page.contentMdx} components={mdxComponents} />
            </div>
          </div>

          {/* Images */}
          <div className="gallery mb-12">
            {page.images.map((image, i) => (
              <div
                key={image.url}
                className={`gallery__item gallery__item--${i + 1} mb-0`}
              >
                <CImage
                  width={"100%"}
                  height={"100%"}
                  src={image.url}
                  alt={image.alt}
                  className="gallery__img rounded-lg"
                />
              </div>
            ))}
          </div>

          {/* Counters */}
          <div className="row">
            <div className="col-12">
              <MDXRemote
                {...page.counters_contentMdx}
                components={mdxComponents}
              />
            </div>
            {page.counters.map((c) => (
              <div key={c.key} className="col-lg-3 col-md-6 col-6">
                <div className="border-top pt-5 mt-6">
                  <h1 className="display-3 fw-bold mb-0">{c.value}</h1>
                  <p className="text-uppercase text-muted">{c.key}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Core values */}
      {/* <div className="py-8 py-lg-16">
        <div className="container">
          <div className="row">
            <div className="col-md-9 col-12 mb-6">
              <MDXRemote
                {...page.core_values_contentMdx}
                components={mdxComponents}
              />
            </div>
          </div>
          <div className="row">
            {page.core_values.map((v) => (
              <div key={v.title} className="col-md-4 col-12">
                <div className="card mb-4 mb-lg-0 h-100">
                  <div className="card-body p-5">
                    <div className="mb-3">
                      <i
                        className={`mdi ${v.icon} mdi-48px text-primary lh-1`}
                      ></i>
                    </div>
                    <h3 className="mb-2">{v.title}</h3>
                    <p className="mb-0">{v.content}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div> 
      </div>*/}

      {/* Our team */}
      <div id="team" className="py-8 py-lg-16 bg-light">
        <div className="container">
          <div className="row">
            <div className="col-md-9 col-12 mb-2">
              <MDXRemote
                {...page.our_team_contentMdx}
                components={mdxComponents}
              />
            </div>
          </div>
          <PersonList people={team} />
        </div>
      </div>
    </>
  );
}

export async function getStaticProps() {
  const page = await getAboutData();
  const team = await getAllPeople();
  const data: AboutData = {
    page,
    team,
  };
  const props = await getGlobalStaticProps(
    { data },
    {
      pageTitle: page.title,
      pageDescription: page.meta_description,
      pageImage: page.image,
      publishDate: page.date,
    }
  );
  return { props };
}
